import * as React from "react";
import { useLayoutEffect } from "./useLayoutEffect.js";
export var useEventCallback = function useEventCallback(fn) {
  var ref = React.useRef(fn);
  useLayoutEffect(function () {
    ref.current = fn;
  });
  return React.useCallback(function () {
    var _a2;
    var _a;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_a = ref.current) === null || _a === void 0 ? void 0 : (_a2 = _a).call.apply(_a2, [ref].concat(args));
  }, []);
};